export default __webpack_public_path__ + "static/media/accomplishment.0c7462c5.jpg";